import makeRequest from "@/api/makeRequest";
import { CreatePayload, EditUserPayload } from "@/api/rest/users/UsersTypes";
import { IUser } from "@/models/User";

const UsersApi = {
  getUsers: async (): Promise<IUser[]> => {
    const { data } = await makeRequest<IUser[]>({
      url: "/users",
    });

    return data;
  },
  create: async (payload: CreatePayload): Promise<IUser> => {
    const { data } = await makeRequest<IUser>({
      url: "/users",
      method: "post",
      data: payload,
    });
    return data;
  },
  edit: async (userId: number, payload: EditUserPayload): Promise<IUser> => {
    const { data } = await makeRequest<IUser>({
      url: `/users/${userId}`,
      method: "put",
      data: payload,
    });
    return data;
  },
  delete: async (userId: number): Promise<void> => {
    await makeRequest<IUser>({
      url: `/users/${userId}`,
      method: "delete",
    });
  },
};

export default UsersApi;
